import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.91 7.967a2.5 2.5 0 01-2.877-2.877 8 8 0 102.877 2.877zm-1.785-4.555a2.5 2.5 0 013.463 3.463A9.954 9.954 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c1.873 0 3.626.515 5.125 1.412zM12 16a4 4 0 110-8 4 4 0 010 8z"
    />
  </svg>
);
